/**
 * Tutorial Video Button Component
 *
 * Renders a video icon button that opens a tutorial video modal when clicked.
 * Encapsulates the modal state, button, and modal rendering in a single component.
 *
 * @see {@link ./tutorial-video-modal.tsx} for the modal implementation
 */

import { useState } from 'react'
import { VideoIcon } from 'lucide-react'
import { Button } from '@bnsn/ui/components/button'
import { TutorialVideoModal } from './tutorial-video-modal'

interface TutorialVideoButtonProps {
  /** Full HTML embed code (e.g. an iframe tag) */
  embedCode: string
}

export const TutorialVideoButton = ({ embedCode }: TutorialVideoButtonProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => setIsOpen(true)}
        aria-label="Watch tutorial video"
        className="shrink-0 text-gray-400 hover:text-gray-600"
      >
        <VideoIcon className="h-5 w-5" />
      </Button>
      <TutorialVideoModal isOpen={isOpen} onOpenChange={setIsOpen} embedCode={embedCode} />
    </>
  )
}
